import {HttpRequest,HttpMethod} from "./http";

class SaleChannelProvider extends HttpRequest {

	// CRUD Product	
	SaleChannelCreate(params) {
		return this.request(HttpMethod.Post,`/api/v1/salechannel`,params );
	}

	SaleChannelList(params) {
		return this.request(HttpMethod.Get,`/api/v1/salechannel`,params );
	}

	SaleChannelUpdate(id,params) {
		return this.request(HttpMethod.Put,`/api/v1/salechannel/${id}`,params );
	}

	SaleChannelDelete(id) {
		return this.request(HttpMethod.Delete,`/api/v1/salechannel/${id}`);
	}


}

export default SaleChannelProvider